import { Background, Spacing } from "@bonusx-global/bx-design-system";
import { headerHeight } from "../../../../../R";
import { HeaderV2LayoutAction } from "../../../../../legacy/components/HeaderV2/stores/header-v2-layout-store";
import type { IHeaderV2Store } from "../../../../../legacy/components/HeaderV2/stores/header-v2-store";
import type { ILayoutStylesStore } from "../../../../../types/layout/layout-styles.type";
import type { IRouteWrapperVariant } from "../../../../../types/layout/route-wrapper-variant.interface";

export class ProfileRouteWrapperVariant implements IRouteWrapperVariant {
  get sidebarAvailable(): boolean {
    return true;
  }

  get headerAvailable(): boolean {
    return true;
  }

  get bottomNavigationAvailable(): boolean {
    return true;
  }

  get layoutStyles(): ILayoutStylesStore {
    return {
      layoutStyles: {
        mobile: { backgroundColor: Background.default, height: "100vh" },
        desktop: {
          backgroundColor: Background.default,
          height: "100vh",
        },
      },
      contentLayoutStyles: {
        mobile: {
          height: `calc(100vh - ${headerHeight})`,
          padding: `0 ${Spacing["1000"]} 0 ${Spacing["1000"]} !important`,
          overflowY: "auto",
        },
        desktop: {
          padding: `0 ${Spacing["8000"]} 0 ${Spacing["8000"]} !important`,
          height: `calc(100vh - ${headerHeight})`,
          maxWidth: "100% !important",
          margin: "0 !important",
          overflowY: "auto",
        },
        desktopOuterContainer: {
          padding: "0 !important",
        },
      },
    };
  }

  get titleAvailable(): boolean {
    return false;
  }

  public getVariantHeaderSettings(): IHeaderV2Store {
    return {
      layoutStore: {
        actions: [HeaderV2LayoutAction.aiAssistant, HeaderV2LayoutAction.search, HeaderV2LayoutAction.notification],
        showLogoOnMobile: true,
      },
    };
  }
}
